import { StylesConfig } from "react-select";

export const customStyles: StylesConfig = {
  menu: (provided) => ({
    ...provided,
    color: "#151515",
    zIndex: 2,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#757575",
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "#0047bb" : "#c6ccd6",
    boxShadow: state.isFocused ? "0 0 0 1px #0047bb" : "#c6ccd6",
    borderRadius: "2px",
    height: 42,
    minHeight: 42,
  }),
  option: (provided, state) => {
    let backgroundColor = state.isFocused ? "#f0f5fd" : "transparent";
    if (state.isSelected) {
      backgroundColor = "#0047bb";
    }

    return {
      ...provided,
      backgroundColor,
      color: state.isSelected ? "#ffffff" : "#151515",
    };
  },
};
